import React, { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from "react-bootstrap";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import '../style.css/custom.css';
import SetCookie from '../utils/setCookie';
import GetCookie from '../utils/getCookie';
import RemoveCookie from '../utils/removeCookie';
   

import loginImg from '../assets/jioLogo.png'
import navLogo from '../assets/jioConsentLogo.png'
import { hideNavbar, otpSend, otpVerify, generateToken, session } from '../store/actions/CommonAction';
import ArrowForward from '@material-ui/icons/ArrowForward';
import TextField from '@mui/material/TextField';


const Login = (props) => {

    // console.log(process.env.REACT_APP_BASE_URL)

    const dispatch = useDispatch();

    // const uuid = useSelector((state) => state.uuid.id);
    // const [localUUID, setLocalUUID] = useState(null);

    const [clientId, setClientId] = useState('');
    const [otpVal, setOtpval] = useState('');
    const [otpValForEmail, setOtpvalForEmail] = useState('');
    const [status, setStatus] = useState(false);
    const [isSendingOTP, setIsSendingOTP] = useState(false);
    const [isVerifyingOTP, setIsVerifyingOTP] = useState(false);
    const [showResendOtp, setShowResendOtp] = useState(false);
    const [counter, setCounter] = useState(59);
    const timerRef = useRef(null);
    // const getProductTheme = useSelector(state => state.common.getProductTheme)
    const [isContinueEnabled, setIsContinueEnabled] = useState(false);

    // const [resendEnabled, setResendEnabled] = useState(false)

    // const reference = useRef(60);

    const mobile = useSelector(state => state.common.mobile)
    //alert("mobile : "+mobile);
    const email = useSelector(state => state.common.email);

    const otpTxnId = useSelector(state => state.common.otpTxnId);
    //alert("email : "+email);

    const handleSubmit = (e) => {
        e.preventDefault();
        //  notify()
    }

    const generateUUID = () => {
        let d = new Date().getTime();
        const d2 = (performance && performance.now && (performance.now() * 1000)) || 0;
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
          const r = Math.random() * 16;
          const v = c === 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
        });
      };

    const sendOTP = async () => {
        
        try {
            if (isSendingOTP) {
                return; // Prevent multiple clicks while sending OTP
            }

            setIsSendingOTP(true);
            document.getElementById("timerDiv").style.display="block";
            document.getElementById("resendDiv").style.display="block";
            setStatus(true);
            startTimer();
           
            await dispatch(otpSend(clientId));
            //alert("otpTxnId : "+otpTxnId);
            
           
        } catch (e) {
            setStatus(false);
            let error = '';
            error = e.message;
           // alert("error" +error);
            if (error.includes('CM1150')) {
                toast.error('Inactive clientId, kindly contact administrator');
            }else if (error.includes('CM5003')) {
                toast.error("Wrong /Invalid client id Please Check!");
            }else if (error.includes('400')) {
                toast.error("Client id used is either inactive or doesn't exist");
            } else toast.error('Something went wrong, please try again later.');
        } finally {
            setIsSendingOTP(false); // Re-enable the button after the request is complete
        }
    };
    const accessToken = useSelector(state => state.common.access_token);
    
    const verify = async () => {
        try {
            if (isVerifyingOTP) {
                return; // Prevent multiple clicks while sending OTP
            }
            setIsVerifyingOTP(true);
            
            const verificationResult = await dispatch(otpVerify(otpVal, otpValForEmail));
    
            if (verificationResult.success) {
                // OTP verified successfully
                SetCookie('usrin', JSON.stringify(accessToken));
    
                // Dispatch the session action
                await dispatch(session());
    
                // Navigate to the next page after a delay
                setTimeout(() => {
                    //nav();
                }, 2000);

                nav();
            } else {
                // toast.error(verificationResult.message || "Invalid/Expired OTP, kindly enter a valid OTP");
            }
    
        } catch (error) {
            toast.error("Something went wrong, please try again later.");
        } finally {
            setIsVerifyingOTP(false); // Re-enable the button after the request is complete
        }
    };
    
    const nav = async () => {
        await dispatch(hideNavbar(true));
        props.history.push("/home");
    };
    
    const maskNameFuncMobile = (mobile) => {
       // alert("mobile : "+mobile)
        if (mobile.length <= 4) {
            return mobile; // If the mobile number is 4 digits or less, return as is
        }
        let maskedPart = mobile.substring(0, mobile.length - 4).replace(/\d/g, "*");
        let lastFourDigits = mobile.substring(mobile.length - 4);
        return maskedPart + lastFourDigits;
    }

    const maskNameFuncEmail = (email) => {
        let atIndex = email.indexOf("@");
        let maskedPart = email.substring(0, atIndex).replace(/./g, "*");
        let domainPart = email.substring(atIndex);
        return maskedPart + domainPart;
    }

    // const startTimer = () => {
    //     const timer = setInterval(() => {
    //       setCounter((prevCounter) => {
    //         if (prevCounter === 0) {
    //           clearInterval(timer);
    //           setShowResendOtp(true);
    //           document.getElementById("timerDiv").style.display = "none"; // Hide the timer when countdown ends
    //           return 59;
    //         } else {
    //           return prevCounter - 1;
    //         }
    //       });
    //     }, 1000);
    //   };





    const startTimer = () => {
        setShowResendOtp(false); // Disable "Resend OTP" button initially
        const timer = setInterval(() => {
            setCounter((prevCounter) => {
                if (prevCounter === 0) {
                    clearInterval(timer);
                    setShowResendOtp(true); // Enable "Resend OTP" button only when the timer completes
                    document.getElementById("timerDiv").style.display = "none"; // Hide the timer when countdown ends
                    return 59;
                } else {
                    return prevCounter - 1;
                }
            });
        }, 1000);
        timerRef.current = timer;
    };

    // Clear the OTP countdown interval when the Login screen unmounts,
    // preventing "state update on an unmounted component" warnings / leaks.
    useEffect(() => {
        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current);
                timerRef.current = null;
            }
        };
    }, []);









    // const handleResendOtp = async () => {
        
    //     setOtpval(Array(6).fill(''));
    //     setOtpvalForEmail(Array(6).fill(''));
    //     // const searchParams = new URLSearchParams(location.search);
    //     // const actionValue = searchParams.get("action");
    
    //     try {
    //         if (isSendingOTP) {
    //             return; // Prevent multiple clicks while sending OTP
    //         }
    //         setIsSendingOTP(true);

    //         await dispatch(otpSend(clientId));
    //         setStatus(true);
    //         toast.success('OTP resent successfully.');
    //     //   setShowResendOtp(false);
    //       setCounter(59);
    //       document.getElementById("timerDiv").style.display = "block"; // Show the timer again
    //       startTimer();
    //     } catch (error) {
    //       toast.error('An error occurred while resending the OTP. Please try again.');
    //       console.error('Error resending OTP:', error);
    //     }
    //   };















    // const handleResendOtp = async () => {
    //     try {
    //         if (isSendingOTP) return; // Prevent multiple clicks while sending OTP
    
    //         setIsSendingOTP(true);
    
    //         // Clear OTP input fields to ensure the user re-enters OTP
    //         setOtpval('');
    //         setOtpvalForEmail('');
    
    //         // Disable the "Continue" button until both OTP fields are re-entered
    //         setShowResendOtp(false);
    //         setCounter(59);
    
    //         // Send OTP
    //         await dispatch(otpSend(clientId));
    //         setStatus(true);
    
    //         toast.success('OTP resent successfully.');
    
    //         // Show timer and start countdown
    //         document.getElementById("timerDiv").style.display = "block";
    //         startTimer();
    //     } catch (error) {
    //         toast.error('An error occurred while resending the OTP. Please try again.');
    //         console.error('Error resending OTP:', error);
    //     } finally {
    //         setIsSendingOTP(false);
    //     }
    // };



// Update the resend button handler
const handleResendOtp = async () => {
    try {
        if (isSendingOTP) return; // Prevent multiple clicks while sending OTP

        setIsSendingOTP(true);

        // Clear OTP input fields to ensure the user re-enters OTP
        setOtpval('');
        setOtpvalForEmail('');

        // Send OTP
        await dispatch(otpSend(clientId));
        setStatus(true);

        toast.success('OTP resent successfully.');

        // Show timer and start countdown
        document.getElementById("timerDiv").style.display = "block";
        startTimer();
    } catch (error) {
        toast.error('An error occurred while resending the OTP. Please try again.');
        console.error('Error resending OTP:', error);
    } finally {
        setIsSendingOTP(false);
    }
};







    
 // Update the OTP input handlers
const handleMobileOtpChange = (e) => {
    const value = e.target.value;
    setOtpval(value);
};

const handleEmailOtpChange = (e) => {
    const value = e.target.value;
    setOtpvalForEmail(value);
};
    
    






      
    
    //   const startTimer = () => {
    //     const timer = setInterval(() => {
    //       setCounter((prevCounter) => {
    //         if (prevCounter === 0) {
    //           clearInterval(timer);
    //           setShowResendOtp(true);
    //           return 59;
    //         } else {
    //           return prevCounter - 1;
    //         }
    //       });
    //     }, 1000);
    //   };
//     useEffect(() => {
//     // Generate a new UUID and store it in local state
//     const newUUID = generateUUID();
//     setLocalUUID(newUUID);
//   }, []);

//     useEffect(() => {
//         if (localUUID) {
//         // Dispatch the UUID to the Redux store
//         dispatch(setUUID(localUUID));
//         }
//     }, [localUUID, dispatch]);

    useEffect(() => {
        //dispatch(generateToken())
        //applyTheme();
        // dispatch(generateBlockChainToken())
    }, [])


    // Enable the "Continue" button only when both OTPs have 6 digits
useEffect(() => {
    if (otpVal.length === 6 && otpValForEmail.length === 6) {
        setIsContinueEnabled(true);
    } else {
        setIsContinueEnabled(false);
    }
}, [otpVal, otpValForEmail]);

    return (
        <>
                <nav class="navbar navbar-default login-nav">
                    <div class="container-fluid">
                        <div class="navbar-header">
                        <a class="navbar-brand" href="#">
                            <img src={navLogo} style={{width:'200px'}}></img>
                        </a>
                        </div>
                       
                    </div>
                    </nav>
        
        <div className="container">

          <div className="row align-items-center vh-100">
            <div className="col-md-7 d-none d-xxl-block d-xl-block d-lg-block d-md-block" style={{marginTop:'6%'}}>
                <font style={{fontSize:'25px', color:'#4445d3', fontWeight:'bold'}}>Simplifying Data Compliance for<br></br> Digital Personal Data Protection Act 2023</font>
                <br></br>
                <font style={{fontSize:'14px', color:'#000', fontWeight:'bold'}}>collect, store and manage the lifecycle of user consent</font>
              <img 
                src='Img/login/bg-1.png'
                className='img-fluid'
              />
            </div>
            <div className="col-md-5" style={{marginTop:'3%'}}>
              <div className='login-box'>
                 <div className="d-flex align-items-center justify-content-center">
                    <img src={loginImg} alt="login" className="img-responsive p-1" style={{ width: '50px', height: '50px', marginLeft: '0%' , marginTop: '0%' }} />
                 </div>
                {/* <h3>Sign In to<span> Partner Portal</span></h3> */}
                <h3 style={{fontSize: '28px'}}>Sign In to Partner Portal</h3>
    
                <form onSubmit={handleSubmit} >
                    <div className="mb-3">
                    <TextField label="Client ID" variant="standard" className='w-100'
                        maxLength="10" minLength="10"
                        required autoFocus
                        onChange={(e) => {
                            setClientId(e.target.value)
                        }}
                        onKeyPress={(event) => {
                            if (!/[a-zA-Z+0-9]/.test(event.key)) {
                                event.preventDefault();
                            }
                        }}
                        disabled={status}
                        
                    />
                    </div>

                    {status &&
                    <div>
                        {mobile && email && <p style={{ color: 'green' }}> OTP has been sent to
                                            <ol><li>Mobile  : {maskNameFuncMobile(mobile)}</li>
                                                <li>Email : {maskNameFuncEmail(email)}</li></ol></p>
                        }
                        <TextField label="OTP from Mobile" variant="standard" className='w-100'
                            type="text"
                            // onChange={(e) => { setOtpval(e.target.value) }}
                            onChange={handleMobileOtpChange}
                            onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                }
                            }}
                            required
                            inputProps={{
                                maxLength: 6, 
                                minLength: 6,
                              }}
                        />
                        <br></br>
                        <br></br>
                        <TextField label="OTP from Email" variant="standard" className='w-100'
                            maxLength="6" minLength="6" type="text"
                            // onChange={(e) => { setOtpvalForEmail(e.target.value) }}
                            onChange={handleEmailOtpChange}
                            onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                }
                            }}
                            required
                            inputProps={{
                                maxLength: 6, 
                                minLength: 6,
                              }}
                        />
                    </div>
                    }

                    <div className='text-center'  style={{paddingTop: '15px'}}>
                        {!status ? (
                                <button
                                    className="btn btn-outline-primary btn-sm"
                                    disabled={isSendingOTP || clientId.length < 10}
                                    onClick={sendOTP}
                                    style={{ float: 'right' }}
                                >
                                    {isSendingOTP ? 'Sending...' : 'Continue '}
                                    <ArrowForward style={{ fontSize: '16px' }} />
                                </button>
                            ) : (
                                <button
                                    className="btn btn-outline-primary-custom btn-sm"
                                    autoFocus={true}
                                    onClick={verify}
                                    // disabled={!(parseInt(isVerifyingOTP || otpVal.length) === 6)}
                                    // disabled={!(otpVal.length === 6 && otpValForEmail.length === 6 && showResendOtp && !isVerifyingOTP)}
                                    disabled={!isContinueEnabled || isVerifyingOTP}
                                    style={{ float: 'right', paddingLeft: '30px', paddingRight: '30px' }}
                                >
                                    {isVerifyingOTP ? 'Continue...' : 'Continue '}
                                    <ArrowForward style={{ fontSize: '16px' }} />
                                </button>
                            )}
        
                    </div>
                    <div className='text-center' >
                        <div className='col-6 text-start'>
                            <button type="button" className='btn btn-primary-custom' style={{display:'none'}} onClick={handleResendOtp} disabled={!showResendOtp} id="resendDiv">Resend OTP</button>

                            {/* <button type="button" className='btn btn-primary' onClick={handleResendOtp} disabled={!showResendOtp}>Resend OTP</button> */}
                        </div>
                        <div className='col-6 text-end timer-div' id="timerDiv">
                                <div className='timer'>({counter} seconds)</div>
                        </div>
                         
                    </div>
                </form>
                
                <small style={{textAlign: 'center', fontSize:'14px', marginTop:'25px', color:'#0a0a0a'}}>For onboarding please send email to <a href="">jioconsent@ril.com</a></small>

                <small style={{textAlign: 'center', fontSize:'13px', fontWeight:'bold', marginTop:'9px', color:'#0a0a0a'}}><a href="https://rilcloud.sharepoint.com/:f:/r/sites/JioConsent_Shared/Shared%20Documents/Production%20Artefacts?csf=1&web=1&e=XRsVQq" target="_blank">Click here</a> for User Guide</small>
              </div>
            </div>
          </div>
        </div>
      </>
    );
}

export default Login


